<script setup lang="ts">
import { Flex } from '@/components'

export interface ButtonGroupProps {
  orientation?: 'horizontal' | 'vertical'
}

const { orientation = 'horizontal' } = defineProps<ButtonGroupProps>()
</script>

<template>
  <Flex :direction="orientation === 'horizontal' ? 'row' : 'column'" :gap="40">
    <slot />
  </Flex>
</template>
